import nanostyled from 'nanostyled';
import Img from 'gatsby-image';

export const Container = nanostyled('section', {
  base: 'w-full typography',
  align: 'mx-auto',
  color: '',
  maxW: 'max-w-5xl',
  border: '',
  margin: '',
});

export const Flex = nanostyled('div', {
  base: 'flex',
  flex: '',
  order: '',
});

export const StyledImage = nanostyled(Img, {
  base: 'flex-shrink-0',
  type: '',
  margin: ' mr-16',
});

export const Margin = nanostyled('div', {
  base: '',
  margin: 'mx-4 xs:mx-10 sm:mx-20',
});
